import { IWebhookFormValues } from './components/WebhookForm';
import { WEBHOOK_AUTH_TYPE } from './types';

export const stripIrrelevantAuthFields = (values: IWebhookFormValues) => {
  const {
    auth_type,
    basic_username,
    basic_password,
    header_name,
    header_value,
    query_parameter,
    query_value,
    ...rest
  } = values;

  if (values.auth_type === WEBHOOK_AUTH_TYPE.BASIC)
    return {
      credentials: {
        auth_type: values.auth_type,
        basic_username,
        basic_password,
      },
      config: rest,
    };
  if (
    values.auth_type === WEBHOOK_AUTH_TYPE.HEADER ||
    values.auth_type === WEBHOOK_AUTH_TYPE.API_KEY
  )
    return {
      credentials: { auth_type: values.auth_type, header_name, header_value },
      config: rest,
    };
  if (values.auth_type === WEBHOOK_AUTH_TYPE.QUERY_PARAMETER)
    return {
      credentials: {
        auth_type: values.auth_type,
        query_parameter,
        query_value,
      },
      config: rest,
    };

  return { credentials: { auth_type: values.auth_type }, config: rest };
};
